import {
    Box,
    Button,
    CircularProgress,
    FormControl,
    IconButton,
    InputAdornment,
    TextField,
    Typography
} from "@mui/material";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {green, light_green} from "../../Utils/style";
import {useState} from "react";
import {
    CAR_SHIPPING,
    CUSTOMS_BROKERAGE,
    HS_CODE_LOOKUP,
    LTL_FREIGHT,
    MOVING_SERVICE,
    PARCEL_PACKAGE
} from "../../Utils/Helper";

export const WordPressMultiConversationChatBotInput = ({
                                                           lng,
                                                           loading,
                                                           service,
                                                           chatHistory,
                                                           cbHandleService,
                                                           cbAddChatIntoChatHistory,
                                                           cbStartNewChat,
                                                           APIRate
                                                       }) => {

    const [inputChat, setInputChat] = useState('');

    const handleInputChat = (event) => {
        const {value} = event?.target;
        setInputChat(value);
    }

    const handleSendChat = () => {
        setInputChat('');
        cbAddChatIntoChatHistory(inputChat);
    }

    const handleNewChat = () => {
        cbStartNewChat();
        setInputChat('');
    }

    const handleServiceType = (service) => {
        cbHandleService(service);
    }

    console.log('[WordPressMultiConversationChatBotInput] inputChat', inputChat);

    return (
        <Box sx={{
            display: 'flex',
            gap: '10px',
            flexDirection: 'column'
        }}>
            <FormControl fullWidth>
                <TextField
                    value={inputChat}
                    multiline={!!service}
                    rows={service ? 4 : 0}
                    onInput={handleInputChat}
                    disabled={!service || loading || APIRate}
                    slotProps={{
                        input: {
                            sx: {
                                position: 'relative',
                                paddingBottom: service ? '45px' : '125px',
                            },
                            endAdornment: (
                                <>
                                    {
                                        loading ?
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    display: 'flex',
                                                    bottom: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)'
                                                }}
                                            >
                                                <CircularProgress/>
                                            </Box>
                                            :
                                            (service && !APIRate) ?
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        bottom: 8,
                                                        left: 8,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '5px',
                                                    }}
                                                >
                                                    <Typography variant="caption"
                                                                sx={{color: 'text.secondary', fontWeight: 'bold'}}>
                                                        {lng === 'cn' ? service?.nameCN : service?.name}
                                                    </Typography>
                                                </Box>
                                                :
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        bottom: 8,
                                                        left: 8,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '5px',
                                                    }}
                                                >
                                                    {/* Shipping Services Group */}
                                                    <Box sx={{display: 'flex', flexDirection: 'column'}}>
                                                        <Typography variant="caption"
                                                                    sx={{color: 'text.secondary', fontWeight: 'bold'}}>
                                                            {lng === 'cn' ? '运输服务' : 'Shipping Services'}
                                                        </Typography>
                                                        <Box sx={{display: 'flex', gap: '10px', flexWrap: 'wrap'}}>
                                                            <Button variant='contained' size='small'
                                                                    onClick={() => handleServiceType(PARCEL_PACKAGE)}>
                                                                <Typography
                                                                    sx={{textTransform: 'none', fontSize: '14px'}}>
                                                                    {lng === 'cn' ? '包裹快递' : 'Parcel Package'}
                                                                </Typography>
                                                            </Button>
                                                            <Button variant='contained' size='small'
                                                                    onClick={() => handleServiceType(LTL_FREIGHT)}>
                                                                <Typography
                                                                    sx={{textTransform: 'none', fontSize: '14px'}}>
                                                                    {lng === 'cn' ? 'LTL零担货运' : 'LTL Freight'}
                                                                </Typography>
                                                            </Button>
                                                            <Button variant='contained' size='small'
                                                                    onClick={() => handleServiceType(MOVING_SERVICE)}>
                                                                <Typography
                                                                    sx={{textTransform: 'none', fontSize: '14px'}}>
                                                                    {lng === 'cn' ? '搬家服务' : 'Moving Service'}
                                                                </Typography>
                                                            </Button>
                                                            <Button variant='contained' size='small'
                                                                    onClick={() => handleServiceType(CAR_SHIPPING)}>
                                                                <Typography
                                                                    sx={{textTransform: 'none', fontSize: '14px'}}>
                                                                    {lng === 'cn' ? '车辆运输' : 'Car Shipping'}
                                                                </Typography>
                                                            </Button>
                                                        </Box>
                                                    </Box>
                                                    {/* Customs Services Group */}
                                                    {/*<Box sx={{display: 'flex', flexDirection: 'column'}}>*/}
                                                    {/*    <Typography variant="caption"*/}
                                                    {/*                sx={{color: 'text.secondary', fontWeight: 'bold'}}>*/}
                                                    {/*        {lng === 'cn' ? '清关服务' : 'Customs Services'}*/}
                                                    {/*    </Typography>*/}
                                                    {/*    <Box sx={{display: 'flex', gap: '10px', flexWrap: 'wrap'}}>*/}
                                                    {/*        <Button variant='contained' size='small'*/}
                                                    {/*                onClick={() => handleServiceType(CUSTOMS_BROKERAGE)}>*/}
                                                    {/*            <Typography*/}
                                                    {/*                sx={{textTransform: 'none', fontSize: '14px'}}>*/}
                                                    {/*                {lng === 'cn' ? '报关代理' : 'Customs Brokerage'}*/}
                                                    {/*            </Typography>*/}
                                                    {/*        </Button>*/}
                                                    {/*        <Button variant='contained' size='small'*/}
                                                    {/*                onClick={() => handleServiceType(HS_CODE_LOOKUP)}>*/}
                                                    {/*            <Typography*/}
                                                    {/*                sx={{textTransform: 'none', fontSize: '14px'}}>*/}
                                                    {/*                {lng === 'cn' ? '海关编码查询' : 'HS Code Lookup'}*/}
                                                    {/*            </Typography>*/}
                                                    {/*        </Button>*/}
                                                    {/*    </Box>*/}
                                                    {/*</Box>*/}
                                                </Box>
                                    }
                                    {
                                        loading &&
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                display: 'flex',
                                                bottom: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)'
                                            }}
                                        >
                                            <CircularProgress/>
                                        </Box>
                                    }
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            bottom: 8,
                                            right: 8,
                                            backgroundColor: green,
                                            borderRadius: '50%',
                                        }}
                                    >
                                        <IconButton
                                            sx={{color: '#FFFFFF'}}
                                            disabled={!inputChat?.trim()}
                                            onClick={handleSendChat}
                                            loading={loading}
                                        >
                                            <ArrowUpwardIcon/>
                                        </IconButton>
                                    </Box>
                                </>
                            ),
                        },
                    }}
                />
            </FormControl>
            <Box sx={{
                display: 'flex',
                justifyContent: 'flex-start'
            }}>
                <FormControl>
                    <Button
                        variant='contained'
                        size='small'
                        onClick={handleNewChat}
                        disabled={chatHistory?.length === 0 || APIRate}
                    >
                        <Typography sx={{textTransform: 'none', fontSize: '14px'}}>
                            {lng === 'cn' ? '开启新对话' : 'New Chat'}
                        </Typography>
                    </Button>
                </FormControl>
            </Box>
        </Box>
    )
}